import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { useAppContext } from "../../../context/app-context";
import useOnClickOutside from "../../../hooks/use-click-outside";
import { SidebarNavItemType } from "../../../types/common";
import DashboardIcon from "../../icons/DashboardIcon";
import ManageStaffIcon from "../../icons/ManageStaffIcon";
import MyClaimsIcon from "../../icons/MyClaimsIcon";
import MyCoverIcon from "../../icons/MyCoverIcon";
import PurchaseIcon from "../../icons/PurchaseIcon";
import "./sidebar.css";

export default function Sidebar() {
  const { t } = useTranslation(["components"]);
  const { isSidebarOpen, hideSidebar, role } = useAppContext();
  const sidebarRef = useRef<HTMLUListElement>(null);
  useOnClickOutside(sidebarRef, hideSidebar);
  const sidenavLinks: SidebarNavItemType[] = [
    {
      icon: (isActive: boolean) => <DashboardIcon isActive={isActive} />,
      label: t("sidebar.menu.dashboard", { ns: "components" }),
      to: "/dashboard",
    },
    {
      icon: (isActive: boolean) => <ManageStaffIcon isActive={isActive} />,
      label: t("sidebar.menu.manage_staff", { ns: "components" }),
      to: "/manage-staff",
      displayWhenRole: ["individual", "business-user"],
    },
    {
      icon: (isActive: boolean) => <PurchaseIcon isActive={isActive} />,
      label: t("sidebar.menu.purchase_cover", { ns: "components" }),
      to: "/purchase-cover",
    },
    {
      icon: (isActive: boolean) => <PurchaseIcon isActive={isActive} />,
      label: t("sidebar.menu.purchase_traditional_insurance", {
        ns: "components",
      }),
      to: "/purchase-traditional-insurance",
    },
    {
      icon: (isActive: boolean) => <MyCoverIcon isActive={isActive} />,
      label: t("sidebar.menu.my_covers", { ns: "components" }),
      to: "/my-covers",
    },
    {
      icon: (isActive: boolean) => <MyClaimsIcon isActive={isActive} />,
      label: t("sidebar.menu.my_claims", { ns: "components" }),
      to: "/my-claims",
    },
  ];

  return (
    <>
      <aside className="">
        <ul
          className={`bg-white box-shadow sidebar ${
            isSidebarOpen ? "sidebar-active" : ""
          } ${role === "individual" ? "" : "sidebar-4"} m-0`}
          ref={sidebarRef}
        >
          {sidenavLinks
            .filter(
              (link) =>
                link?.displayWhenRole?.length !== 0 &&
                !link.displayWhenRole?.includes(role)
            )
            .map((link) => {
              return (
                <li className="text-center mb-md-4" key={link.label}>
                  <NavLink className="text-decoration-none" to={link.to}>
                    {({ isActive }) => {
                      return (
                        <>
                          <span className="d-inline-block mb-1">
                            {link.icon(isActive)}
                          </span>
                          <span
                            className={`d-inline-block sidebar-label ${
                              isActive ? "active" : ""
                            }`}
                          >
                            {link.label}
                          </span>
                        </>
                      );
                    }}
                  </NavLink>
                </li>
              );
            })}
        </ul>
      </aside>
    </>
  );
}
